import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { ApiService } from "src/app/_services/api.service";
import { GlobalService } from "src/app/_services/global.service";
import { LanguageService } from 'src/app/_services/language.service';


@Component({
  selector: 'app-opportunities',
  standalone: false,
  templateUrl: './opportunities.component.html',
  styleUrl: './opportunities.component.scss',
  providers: [MessageService,ConfirmationService]
})
export class OpportunitiesComponent implements OnInit {
  expandedRows = {};

  statusCellaOptions:any[]=[];
  from_date=new Date();
  to_date=new Date();
  columnsOppourtunities:any[]=[];
  opportunitiesData:any[]=[];
  isLoaded:boolean=true;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public lang : LanguageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {  
    
    
    this.from_date.setDate(this.from_date.getDate() - 7);
    this.load();
    this.statusCellaOptions=[
      {
        value:'NUOVA',
        label:this.lang.el('NUOVA')
      },
      {
        value:'IN PROGETTAZIONE',
        label:this.lang.el('IN PROGETTAZIONE')
      },
      {
        value:'CONFERMATA',
        label:this.lang.el('CONFERMATA')
      }
    ];
    /*
    if(this.isInvioBCEnabled()){
      this.statusCellaOptions.push({
        value:'INVIATA BC',
        label:this.lang.el('INVIATA BC')
      });
    }
    */
  }
  
  
  isInvioBCEnabled(){

    if(this.globalService.getUser().organization=='MISA' || this.globalService.getUser().role=='AMMINISTRATORE'){
      return true;
    } 
                               
    return false;
  }

  load(){
    let user_id=this.globalService.getUser().id;
    let params:any={logged_user_id:user_id};
    if(this.from_date){
      params.from_date=this.from_date;
    }
    if(this.to_date){
      params.to_date=this.to_date;
    }
    this.isLoaded=true;
    this.apiService.post('app/opportunities_listall',params).subscribe(data2 => {
      this.opportunitiesData = data2.Result;
      this.isLoaded =false;
      this.opportunitiesData=[...this.opportunitiesData];
    });
  }
  
  expandAll() {
      this.expandedRows = this.opportunitiesData.reduce((acc, p) => (acc[p.id] = true) && acc, {});
  }

  collapseAll() {
      this.expandedRows = {};
  }


  nuovoPreventivo(){
     this.router.navigateByUrl('opportunities/opportunity-edit/new');
  }
  getSeverityCella(status: string) {
      switch (status) {
          case 'CONFERMATA':
              return 'success';
          case 'IN PROGETTAZIONE':
              return 'warning';
      }
      return 'info';
  }
   
  editPrev(record:any){
    this.router.navigateByUrl('opportunities/opportunity-edit/update/'+record.id);
  }
  
  onGlobalFilter(table: any, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
    
  duplicate(record:any){
  this.apiService.post('app/opportunity_duplicate',{id:record.id,loggedUser:this.globalService.getUser().id}).subscribe(data2 => {
      this.router.navigateByUrl('opportunities/opportunity-edit/update/'+data2.Result);
    });
  }
  
  deleteOpp(record:any){
    this.confirmationService.confirm({
        message: this.lang.el('Si conferma la cancellazione del record?'),
        header: this.lang.el('Conferma'),
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:this.lang.el('Annulla'),
        acceptLabel:this.lang.el('Conferma'),
        accept: () => {
      
          this.apiService.post('app/opportunity_delete',{id:record.id}).subscribe(data2 => {
            this.messageService.add({ severity: 'warning', summary: 'Eliminato', detail: this.lang.el('Record cancellato') });
            this.opportunitiesData = this.opportunitiesData.filter((item:any) => item.id !== record.id);
          });
          
        },
        reject: () => {
           
        },
    });
 
  
  }

  
}
